import { render } from "./DeviceDetailsRemoveMpidOverlay.vue?vue&type=template&id=b6ec66a2&scoped=true"
import script from "./DeviceDetailsRemoveMpidOverlay.vue?vue&type=script&lang=js"
export * from "./DeviceDetailsRemoveMpidOverlay.vue?vue&type=script&lang=js"

import "./DeviceDetailsRemoveMpidOverlay.vue?vue&type=style&index=0&id=b6ec66a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6ec66a2"]])

export default __exports__